<template>
  <div id="quote-services-create">
    <b-form @submit.prevent="submitQuote">
      <b-row>
        <b-col>
          <b-row>
            <b-col class="form-group mb-2">
              <label class="control-label" v-translate>Quote For Service</label>
              <b-form-select v-model="quote.service_id" :options="servicesSelect" class="mb-3" required :disabled="readOnly || Boolean(quoteData)">
                <template slot="first">
                  <option :value="null"><translate>Select Service</translate></option>
                </template>
              </b-form-select>
            </b-col>
            <b-col class="form-group mb-2" v-if="isInternational">
              <label class="control-label" v-translate>Quote Country</label>
              <b-form-select v-model="quote.country_id" :options="countriesByIdSelect" class="mb-3" required :disabled="readOnly || Boolean(quoteData)">
                <template slot="first">
                  <option :value="null"><translate>Select Country</translate></option>
                </template>
              </b-form-select>
            </b-col>
          </b-row>
          <div class="form-group mb-2">
            <label class="control-label" v-translate>Price Formula</label>
            <b-input-group>
              <b-form-input ref="formula" class="" type="text" v-model="quote.price_formula" required :disabled="readOnly"></b-form-input>
              <b-input-group-append>
                <b-input-group-text>{{quote.currency}}</b-input-group-text>
              </b-input-group-append>
            </b-input-group>
          </div>
          <div class="form-group mb-2">
            <label class="control-label" v-translate>Courier Commission Formula</label>
            <small tabindex="-1" class="form-text text-muted" v-translate>Must be simple and it doesn't support Custom Values (ie. <em>{servicePrice}*0.5</em>)</small>
            <input ref="courierCommissionFormula" class="form-control form-control-lg mb-3" type="text" v-model="quote.courier_commission_formula" required :disabled="readOnly">
            <p v-if="!readOnly"><label class="control-label" v-translate>Variable</label>
              <b-button style="padding: 0.1rem 1rem;" @click.prevent="quote.courier_commission_formula = quote.courier_commission_formula + '{servicePrice}'; $refs.courierCommissionFormula.focus()">{servicePrice}</b-button>
            </p>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-row>
            <div class="form-group mb-2 col-6">
              <label class="control-label" v-translate>Minimum Price</label>
              <b-form-input v-model="quote.min_price" type="number" class="mb-3" :disabled="readOnly" />
            </div>
            <div class="form-group mb-2 col-6">
              <label class="control-label" v-translate>Maximum Price</label>
              <b-form-input v-model="quote.max_price" type="number" class="mb-3" :disabled="readOnly" />
            </div>
          </b-row>
          <b-row v-if="!quoteData || quoteCompanies.length === 1">
            <div class="form-group mb-2 col-6">
              <label class="control-label" v-translate>Companies</label>
              <company-autocomplete :disabled="readOnly || quoteData" v-if="!readOnly && quoteCompanies.length === 0" ref="companyAc" @selected="onSearchCompanySelected" />
              <b-badge v-for="(item, index) in quoteCompanies" :key="index" style="margin-right: 3px">
                {{ item.name }} <b-badge variant="danger" href="#" @click.prevent="removeCompanyFromQuote(index)" v-if="!readOnly && !quoteData">×</b-badge>
              </b-badge>
            </div>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="mt-3" v-if="!readOnly">
        <div class="text-center form-group col-12 form-actions">
          <b-button type="submit" variant="primary" size="lg" v-translate>Save Quote</b-button>
          <b-button type="reset" variant="outline-primary" size="lg" @click.prevent="resetData" v-translate>Cancel</b-button>
        </div>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import CompanyAutocomplete from '@/components/autocompletes/CompanyAutocomplete'

export default {
  name: 'QuoteServicesCreate',
  components: {
    CompanyAutocomplete
  },
  props: {
    quoteData: {
      type: Object,
      default: null
    },
    baseCompany: {
      type: Object,
      default: null
    },
    isModal: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      quote: {
        service_id: null,
        country_id: null,
        company_id: null,
        currency: null,
        price_formula: '',
        courier_commission_formula: '',
        min_price: null,
        max_price: null
      },
      quoteCompanies: [],
      searchCompanyQuery: '',
      acCompanyOptions: {
        debounce: 500,
        placeholder: this.$gettext('Company Name'),
        inputClass: 'form-control'
      },
      minCharacter: 2,
      company: null
    }
  },
  watch: {
    'quote.country_id': {
      handler(val) {
        console.log(val)
        if (val) {
          this.quote.currency = window.countries.findIndex(x => x.id === val) !== -1 ? window.countries.find(x => x.id === val).currency : null
        } else {
          this.quote.currency = null
        }
      },
      deep: true
    }
    // company(val) {
    //   console.log('ARGH')
    //   if (val !== null) {
    //     this.quote.type = 'company'
    //     this.quote.company_id = val.id
    //   } else {
    //     this.quotes.type = null
    //     this.quotes.companyId = null
    //   }
    // }
  },
  created() {
    this.fetchServices()
    this.fetchCountries()
  },
  mounted() {
    if (!this.isInternational) {
      this.quote.country_id = window.countries.find(x => x.iso_code === window.country).id
    }
    if (this.baseCompany) {
      this.quoteCompanies = [{
        id: this.baseCompany.id,
        name: this.baseCompany.name
      }]
      this.quote.company_id = this.baseCompany.id
      this.quote.country_id = window.countries.find(x => x.iso_code === this.baseCompany.country_iso_code).id
    }
    if (this.quoteData) {
      this.quote = {...this.quoteData}
      if (this.quoteData.company) {
        this.quoteCompanies = [{...this.quoteData.company}]
      }
    }
  },
  methods: {
    submitQuote() {
      if (!this.quoteData) {
        this.$http.post(this.$appConfig.api.baseUrl + 'quote-services', this.quote)
          .then(response => {
            console.log(response.body)
            if (!this.isModal) {
              this.$router.push({ name: 'modelList', params: { type: 'quote-services' }, query: { created: true } })
            } else {
              this.$emit('quotecreated', response.body)
            }
          })
      } else {
        this.$http.patch(this.$appConfig.api.baseUrl + 'quote-services/' + this.quote.id, this.quote)
          .then(response => {
            if (!this.isModal) {
              this.$router.push({ name: 'modelList', params: { type: 'quote-services' }, query: { created: true } })
            } else {
              this.$emit('quoteupdated', response.body)
            }
          })
      }
    },
    onSearchCompanySelected(item) {
      this.quote.company_id = item.id
      this.quoteCompanies.push({id: item.id, name: item.name})
      this.$refs.companyAc.searchQuery = ''
    },
    removeCompanyFromQuote(index) {
      this.quote.company_id = null
      this.quoteCompanies.splice(index, 1)
    },
    // camelToSnake(key) {
    //   return key.replace(/([A-Z])/g, '_$1').toLowerCase()
    // },
    resetData: function () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.$emit('cancel')
    }
  }
}
</script>
